// Module
var code = "like this board? - <a href=\"#\" class=\"copy-dashboard\">copy it to your Google drive</a>";
// Exports
export default code;